import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { url } from '../../static/env';
import file_img from '../../static/img/file.png';
import './documents.css';

function cleanFileName(fileName) {
    const dotIndex = fileName.lastIndexOf('.');
    const ext = fileName.slice(dotIndex);
    let base = fileName.slice(0, dotIndex);
    if (base.includes('-')) {
        base = base.split('-').slice(0, -1).join('-');
    }
    return base + ext;
}

function formatSize(size) {
    if (!size) return '';
    if (size < 1024) return `${size} B`;
    if (size < 1024 ** 2) return `${(size / 1024).toFixed(1)} KB`;
    if (size < 1024 ** 3) return `${(size / (1024 ** 2)).toFixed(1)} MB`;
    return `${(size / (1024 ** 3)).toFixed(1)} GB`;
}

const FileMessage = ({ path, size, fileAction = 'download', qrPath = null, compactQr = false }) => {
    const isWav = path ? path.endsWith('.wav') : false;
    const isImage = path ? ['.png', '.jpg', '.jpeg', '.bmp', '.gif', '.tiff'].some(ext => path.endsWith(ext)) : false;

    const [choiceOpen, setChoiceOpen] = useState(false);
    const [qrModalOpen, setQrModalOpen] = useState(false);

    const handleDownload = async () => {
        const fileName = cleanFileName(path.split('/').pop());
        const response = await fetch(`${url}/${path}`);
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
    };

    const handleOpenInNewTab = () => {
        window.open(`${url}/${path}`, '_blank', 'noopener,noreferrer');
        setChoiceOpen(false);
    };

    const onRowClick = () => {
        if (fileAction === 'choice') {
            setChoiceOpen(true);
        } else {
            handleDownload();
        }
    };

    const fileName = cleanFileName(path.split('/').pop());
    const sizeText = formatSize(size);
    const qrSrc = qrPath ? `${url}/${qrPath}` : null;

    const choiceModal = choiceOpen && createPortal(
        <div
            className="file-action-overlay"
            role="presentation"
            onClick={() => setChoiceOpen(false)}
        >
            <div
                className="file-action-card"
                role="dialog"
                aria-modal="true"
                aria-labelledby="file-action-filename"
                onClick={(e) => e.stopPropagation()}
            >
                <p id="file-action-filename" className="file-action-title manrope-bold">
                    {fileName}
                </p>
                <div className="file-action-buttons">
                    <button
                        type="button"
                        className="file-action-btn file-action-btn-open manrope-bold"
                        onClick={() => {
                            handleOpenInNewTab();
                        }}
                    >
                        Открыть
                    </button>
                    <button
                        type="button"
                        className="file-action-btn file-action-btn-save manrope-bold"
                        onClick={async () => {
                            await handleDownload();
                            setChoiceOpen(false);
                        }}
                    >
                        Сохранить
                    </button>
                    <button
                        type="button"
                        className="file-action-btn file-action-btn-cancel manrope-bold"
                        onClick={() => setChoiceOpen(false)}
                    >
                        Отмена
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );

    const qrModal = qrModalOpen && qrSrc && createPortal(
        <div
            className="file-action-overlay"
            role="presentation"
            onClick={() => setQrModalOpen(false)}
        >
            <div
                className="file-qr-modal-card"
                role="dialog"
                aria-modal="true"
                aria-labelledby="file-qr-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <p id="file-qr-modal-title" className="file-qr-modal-title manrope-bold">
                    QR для оплаты
                </p>
                <p className="file-qr-modal-hint manrope-400">
                    Наведите камеру телефона на код
                </p>
                <img
                    className="file-qr-modal-image"
                    src={qrSrc}
                    alt="QR для оплаты"
                />
                <button
                    type="button"
                    className="file-action-btn file-action-btn-cancel manrope-bold"
                    style={{ width: '100%' }}
                    onClick={() => setQrModalOpen(false)}
                >
                    Закрыть
                </button>
            </div>
        </div>,
        document.body
    );

    return (
        <div>
            {isWav && (
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '8px' }}>
                    <span style={{ flex: 5 }}>AUDIO</span>
                    <audio style={{ flex: 1 }} src={`${url}/${path}`} controls />
                </div>
            )}
            {isImage && (
                <div style={{ marginBottom: '10px' }}>
                    <img
                        src={`${url}/${path}`}
                        alt={fileName}
                        style={{ width: '100px', height: '100px', borderRadius: '10px' }}
                    />
                </div>
            )}
            <div
                onClick={onRowClick}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onRowClick();
                    }
                }}
                role={fileAction === 'choice' ? 'button' : undefined}
                tabIndex={fileAction === 'choice' ? 0 : undefined}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    cursor: 'pointer',
                    gap: '8px',
                    justifyContent: 'space-between',
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
                    <img
                        src={file_img}
                        alt="Файл"
                        style={{ width: '24px', height: '24px', flexShrink: 0 }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '85%' }}>
                        <span style={{ fontWeight: 'bold', color: 'black', wordBreak: 'break-word', whiteSpace: 'normal' }}>{fileName}</span>
                        <span style={{ fontSize: '12px', color: 'gray' }}>{sizeText}</span>
                    </div>
                </div>
                {qrSrc && (
                    <img
                        src={qrSrc}
                        alt="QR для оплаты"
                        title="Открыть QR для сканирования"
                        className={`file-qr-thumb${compactQr ? ' file-qr-thumb--compact' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            setQrModalOpen(true);
                        }}
                    />
                )}
            </div>
            {choiceModal}
            {qrModal}
        </div>
    );
};

export default FileMessage;
